module.exports = __webpack_public_path__ + "img/cerulean.87a96b64.png";